import { useTranslation } from 'react-i18next';
import ErrorPageTempate from './ErrorPageTempate';

function Error403() {
  const { t } = useTranslation();

  return (
    <ErrorPageTempate
      label={t('Error: Forbidden.')}
      code={403}
    />
  );
}

export default Error403;
